import styled from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const Box = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  padding: 5px 0 10px;
  margin-bottom: 10px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const Button = styled.button`
  ${commonButton}
  margin: 0 10px;

  ${Media.md`
    margin: 5px;
  `}
`;
